export default {
  ac: "1f1e6-1f1e8",
  ad: "1f1e6-1f1e9",
  ae: "1f1e6-1f1ea",
  af: "1f1e6-1f1eb",
  ag: "1f1e6-1f1ec",
  ai: "1f1e6-1f1ee",
  al: "1f1e6-1f1f1",
  am: "1f1e6-1f1f2",
  ao: "1f1e6-1f1f4",
  aq: "1f1e6-1f1f6",
  ar: "1f1e6-1f1f7",
  as: "1f1e6-1f1f8",
  at: "1f1e6-1f1f9",
  au: "1f1e6-1f1fa",
  aw: "1f1e6-1f1fc",
  ax: "1f1e6-1f1fd",
  az: "1f1e6-1f1ff",
  ba: "1f1e7-1f1e6",
  bb: "1f1e7-1f1e7",
  bd: "1f1e7-1f1e9",
  be: "1f1e7-1f1ea",
  bf: "1f1e7-1f1eb",
  bg: "1f1e7-1f1ec",
  bh: "1f1e7-1f1ed",
  bi: "1f1e7-1f1ee",
  bj: "1f1e7-1f1ef",
  bl: "1f1e7-1f1f1",
  bm: "1f1e7-1f1f2",
  bn: "1f1e7-1f1f3",
  bo: "1f1e7-1f1f4",
  bq: "1f1e7-1f1f6",
  br: "1f1e7-1f1f7",
  bs: "1f1e7-1f1f8",
  bt: "1f1e7-1f1f9",
  bv: "1f1e7-1f1fb",
  bw: "1f1e7-1f1fc",
  by: "1f1e7-1f1fe",
  bz: "1f1e7-1f1ff",
  ca: "1f1e8-1f1e6",
  cc: "1f1e8-1f1e8",
  cd: "1f1e8-1f1e9",
  cf: "1f1e8-1f1eb",
  cg: "1f1e8-1f1ec",
  ch: "1f1e8-1f1ed",
  ci: "1f1e8-1f1ee",
  ck: "1f1e8-1f1f0",
  cl: "1f1e8-1f1f1",
  cm: "1f1e8-1f1f2",
  cn: "1f1e8-1f1f3",
  co: "1f1e8-1f1f4",
  cp: "1f1e8-1f1f5",
  cr: "1f1e8-1f1f7",
  cu: "1f1e8-1f1fa",
  cv: "1f1e8-1f1fb",
  cw: "1f1e8-1f1fc",
  cx: "1f1e8-1f1fd",
  cy: "1f1e8-1f1fe",
  cz: "1f1e8-1f1ff",
  de: "1f1e9-1f1ea",
  dg: "1f1e9-1f1ec",
  dj: "1f1e9-1f1ef",
  dk: "1f1e9-1f1f0",
  dm: "1f1e9-1f1f2",
  do: "1f1e9-1f1f4",
  dz: "1f1e9-1f1ff",
  ea: "1f1ea-1f1e6",
  ec: "1f1ea-1f1e8",
  ee: "1f1ea-1f1ea",
  eg: "1f1ea-1f1ec",
  eh: "1f1ea-1f1ed",
  er: "1f1ea-1f1f7",
  es: "1f1ea-1f1f8",
  et: "1f1ea-1f1f9",
  eu: "1f1ea-1f1fa",
  fi: "1f1eb-1f1ee",
  fj: "1f1eb-1f1ef",
  fk: "1f1eb-1f1f0",
  fm: "1f1eb-1f1f2",
  fo: "1f1eb-1f1f4",
  fr: "1f1eb-1f1f7",
  ga: "1f1ec-1f1e6",
  gb: "1f1ec-1f1e7",
  gd: "1f1ec-1f1e9",
  ge: "1f1ec-1f1ea",
  gf: "1f1ec-1f1eb",
  gg: "1f1ec-1f1ec",
  gh: "1f1ec-1f1ed",
  gi: "1f1ec-1f1ee",
  gl: "1f1ec-1f1f1",
  gm: "1f1ec-1f1f2",
  gn: "1f1ec-1f1f3",
  gp: "1f1ec-1f1f5",
  gq: "1f1ec-1f1f6",
  gr: "1f1ec-1f1f7",
  gs: "1f1ec-1f1f8",
  gt: "1f1ec-1f1f9",
  gu: "1f1ec-1f1fa",
  gw: "1f1ec-1f1fc",
  gy: "1f1ec-1f1fe",
  hk: "1f1ed-1f1f0",
  hm: "1f1ed-1f1f2",
  hn: "1f1ed-1f1f3",
  hr: "1f1ed-1f1f7",
  ht: "1f1ed-1f1f9",
  hu: "1f1ed-1f1fa",
  ic: "1f1ee-1f1e8",
  id: "1f1ee-1f1e9",
  ie: "1f1ee-1f1ea",
  il: "1f1ee-1f1f1",
  im: "1f1ee-1f1f2",
  in: "1f1ee-1f1f3",
  io: "1f1ee-1f1f4",
  iq: "1f1ee-1f1f6",
  ir: "1f1ee-1f1f7",
  is: "1f1ee-1f1f8",
  it: "1f1ee-1f1f9",
  je: "1f1ef-1f1ea",
  jm: "1f1ef-1f1f2",
  jo: "1f1ef-1f1f4",
  jp: "1f1ef-1f1f5",
  ke: "1f1f0-1f1ea",
  kg: "1f1f0-1f1ec",
  kh: "1f1f0-1f1ed",
  ki: "1f1f0-1f1ee",
  km: "1f1f0-1f1f2",
  kn: "1f1f0-1f1f3",
  kp: "1f1f0-1f1f5",
  kr: "1f1f0-1f1f7",
  kw: "1f1f0-1f1fc",
  ky: "1f1f0-1f1fe",
  kz: "1f1f0-1f1ff",
  la: "1f1f1-1f1e6",
  lb: "1f1f1-1f1e7",
  lc: "1f1f1-1f1e8",
  li: "1f1f1-1f1ee",
  lk: "1f1f1-1f1f0",
  lr: "1f1f1-1f1f7",
  ls: "1f1f1-1f1f8",
  lt: "1f1f1-1f1f9",
  lu: "1f1f1-1f1fa",
  lv: "1f1f1-1f1fb",
  ly: "1f1f1-1f1fe",
  ma: "1f1f2-1f1e6",
  mc: "1f1f2-1f1e8",
  md: "1f1f2-1f1e9",
  me: "1f1f2-1f1ea",
  mf: "1f1f2-1f1eb",
  mg: "1f1f2-1f1ec",
  mh: "1f1f2-1f1ed",
  mk: "1f1f2-1f1f0",
  ml: "1f1f2-1f1f1",
  mm: "1f1f2-1f1f2",
  mn: "1f1f2-1f1f3",
  mo: "1f1f2-1f1f4",
  mp: "1f1f2-1f1f5",
  mq: "1f1f2-1f1f6",
  mr: "1f1f2-1f1f7",
  ms: "1f1f2-1f1f8",
  mt: "1f1f2-1f1f9",
  mu: "1f1f2-1f1fa",
  mv: "1f1f2-1f1fb",
  mw: "1f1f2-1f1fc",
  mx: "1f1f2-1f1fd",
  my: "1f1f2-1f1fe",
  mz: "1f1f2-1f1ff",
  na: "1f1f3-1f1e6",
  nc: "1f1f3-1f1e8",
  ne: "1f1f3-1f1ea",
  nf: "1f1f3-1f1eb",
  ng: "1f1f3-1f1ec",
  ni: "1f1f3-1f1ee",
  nl: "1f1f3-1f1f1",
  no: "1f1f3-1f1f4",
  np: "1f1f3-1f1f5",
  nr: "1f1f3-1f1f7",
  nu: "1f1f3-1f1fa",
  nz: "1f1f3-1f1ff",
  om: "1f1f4-1f1f2",
  pa: "1f1f5-1f1e6",
  pe: "1f1f5-1f1ea",
  pf: "1f1f5-1f1eb",
  pg: "1f1f5-1f1ec",
  ph: "1f1f5-1f1ed",
  pk: "1f1f5-1f1f0",
  pl: "1f1f5-1f1f1",
  pm: "1f1f5-1f1f2",
  pn: "1f1f5-1f1f3",
  pr: "1f1f5-1f1f7",
  ps: "1f1f5-1f1f8",
  pt: "1f1f5-1f1f9",
  pw: "1f1f5-1f1fc",
  py: "1f1f5-1f1fe",
  qa: "1f1f6-1f1e6",
  re: "1f1f7-1f1ea",
  ro: "1f1f7-1f1f4",
  rs: "1f1f7-1f1f8",
  ru: "1f1f7-1f1fa",
  rw: "1f1f7-1f1fc",
  sa: "1f1f8-1f1e6",
  sb: "1f1f8-1f1e7",
  sc: "1f1f8-1f1e8",
  sd: "1f1f8-1f1e9",
  se: "1f1f8-1f1ea",
  sg: "1f1f8-1f1ec",
  sh: "1f1f8-1f1ed",
  si: "1f1f8-1f1ee",
  sj: "1f1f8-1f1ef",
  sk: "1f1f8-1f1f0",
  sl: "1f1f8-1f1f1",
  sm: "1f1f8-1f1f2",
  sn: "1f1f8-1f1f3",
  so: "1f1f8-1f1f4",
  sr: "1f1f8-1f1f7",
  ss: "1f1f8-1f1f8",
  st: "1f1f8-1f1f9",
  sv: "1f1f8-1f1fb",
  sx: "1f1f8-1f1fd",
  sy: "1f1f8-1f1fe",
  sz: "1f1f8-1f1ff",
  ta: "1f1f9-1f1e6",
  tc: "1f1f9-1f1e8",
  td: "1f1f9-1f1e9",
  tf: "1f1f9-1f1eb",
  tg: "1f1f9-1f1ec",
  th: "1f1f9-1f1ed",
  tj: "1f1f9-1f1ef",
  tk: "1f1f9-1f1f0",
  tl: "1f1f9-1f1f1",
  tm: "1f1f9-1f1f2",
  tn: "1f1f9-1f1f3",
  to: "1f1f9-1f1f4",
  tr: "1f1f9-1f1f7",
  tt: "1f1f9-1f1f9",
  tv: "1f1f9-1f1fb",
  tw: "1f1f9-1f1fc",
  tz: "1f1f9-1f1ff",
  ua: "1f1fa-1f1e6",
  ug: "1f1fa-1f1ec",
  um: "1f1fa-1f1f2",
  us: "1f1fa-1f1f8",
  uy: "1f1fa-1f1fe",
  uz: "1f1fa-1f1ff",
  va: "1f1fb-1f1e6",
  vc: "1f1fb-1f1e8",
  ve: "1f1fb-1f1ea",
  vg: "1f1fb-1f1ec",
  vi: "1f1fb-1f1ee",
  vn: "1f1fb-1f1f3",
  vu: "1f1fb-1f1fa",
  wf: "1f1fc-1f1eb",
  ws: "1f1fc-1f1f8",
  xk: "1f1fd-1f1f0",
  ye: "1f1fe-1f1ea",
  yt: "1f1fe-1f1f9",
  za: "1f1ff-1f1e6",
  zm: "1f1ff-1f1f2",
  zw: "1f1ff-1f1fc",
};
